let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("18UCy")).then(() => parcelRequire('iHHcK'));